import { motion, AnimatePresence } from "framer-motion";
import { X, ScrollText } from "lucide-react";
import { useApp } from "@/context/AppProviders";

const Terms = () => {
  const { t, termsOpen, setTermsOpen } = useApp();
  const tr = t.terms;

  return (
    <AnimatePresence>
      {termsOpen && (
        <div
          className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 backdrop-blur-sm px-4 py-8"
          onClick={() => setTermsOpen(false)}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.96, y: 12 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96 }}
            transition={{ duration: 0.25 }}
            onClick={(e) => e.stopPropagation()}
            data-testid="terms-modal"
            className="relative flex max-h-[85vh] w-full max-w-2xl flex-col rounded-sm border border-border bg-card"
          >
            <div className="flex items-center justify-between gap-4 border-b border-border p-6">
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-sm bg-blue-600/10 text-blue-500">
                  <ScrollText className="h-5 w-5" />
                </div>
                <div>
                  <h3 className="font-heading text-lg font-semibold tracking-tight">
                    {tr.title}
                  </h3>
                  <p className="text-xs text-muted-foreground">{tr.subtitle}</p>
                </div>
              </div>
              <button
                onClick={() => setTermsOpen(false)}
                data-testid="terms-close"
                aria-label="Close"
                className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-sm text-muted-foreground hover:bg-secondary transition-colors"
              >
                <X className="h-4 w-4" />
              </button>
            </div>

            <div className="space-y-6 overflow-y-auto p-6">
              {tr.articles.map((a, i) => (
                <div key={i} data-testid={`terms-article-${i}`}>
                  <h4 className="font-heading text-sm font-semibold tracking-tight text-foreground">
                    {a.title}
                  </h4>
                  <ul className="mt-2 space-y-2">
                    {a.items.map((it, j) => (
                      <li
                        key={j}
                        className="text-sm leading-relaxed text-muted-foreground"
                      >
                        {it}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="border-t border-border p-4 text-right">
              <button
                onClick={() => setTermsOpen(false)}
                className="inline-flex h-10 items-center justify-center rounded-sm bg-blue-600 px-5 text-sm font-medium text-white hover:bg-blue-500 transition-colors duration-200"
              >
                {tr.close}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default Terms;
